import GA4React from "ga-4-react";
import api from "./Services/api";

class Helper {

	private component: any;

	constructor(component: any) {
		this.component = component;
	}

	public init(Identificador:string) {

		if (!this.component.state.isLoaded) {
			this.component.setState({ isLoaded: true });

			api.get(`/ObterLayoutPaginaFiltro?v=1&Identificador=${Identificador}`)
				.then((response) => {
					const result = response.data.results.filter((r: { Identificador: string; }) => r?.Identificador.toUpperCase() === Identificador.toUpperCase());

					this.component.setState({ result });

					try {
						const ga4react = new GA4React(
							'G-47LVY79GP4',
							{},
							[],
							3000
						);
						ga4react.initialize().then((ga4) => {
							ga4.pageview(window.location.pathname + window.location.search, undefined, decodeURIComponent(document.title));
						}, (err) => {
							console.error(err);
						});

					} catch (err) {
						console.error(err);
					}
				})
				.catch((err) => {
					throw new Error(err);
				});
		}
	}
}
export default Helper;